module.exports = __webpack_public_path__ + "static/petronas-305cd60e67ad1c1197e4f043ec80e886.png";